import { ArticleHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatWindowInitial.css';

type TProps = {
  backgroundImageUrl: string | null;
};

export const ChatWindowInitial: React.FC<TProps> = ({ backgroundImageUrl }) => {
  return (
    <div
      className={styles['container']}
      style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined }}
    >
      <ArticleHeading5 color="text-secondary-default">Для начала выберите чат</ArticleHeading5>
    </div>
  );
};
